module.exports = __webpack_public_path__ + "static/media/Sekcja2.4965a198.jpg";